import template from './ko-field-input-boolean.html';

class BooleanInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.readonly = ko.observable(params.readonly);
	}
}


export default {
	name: 'ko-field-input-boolean',
	viewModel: BooleanInputComponentVM,
	module_type: 'ko',
	template: template
}
